module.exports = __webpack_public_path__ + "static/media/1002282.587c2a0d.png";